import { useEffect } from 'react';
import { DESKTOP_LAYOUT_MEDIA_QUERY, useMediaQuery } from '@/hooks/useMediaQuery';
import { isPhoneNavigation } from '@/shell/usePhoneNavigation';

/**
 * IU-4 (`docs/concept-iphone-ux.md#iu-4-phone-type-and-spacing`): the one attribute
 * `phone-type.css` keys on, `data-phone-type-scale` on `<html>`, set from `isPhoneNavigation()` —
 * the same predicate IU-3's handshake and AC-18 use, so phone and desktop type never drift from
 * two independently derived "is this phone mode" conditions (the concept's own ruling, *Risks*:
 * "never re-derive the condition").
 *
 * Mounted once, in `index.tsx`, outside `<App />` — not inside `Layout.tsx`/`App.tsx`/
 * `ShellRuntime.tsx`, each another lane's open file this session.
 */
export function usePhoneTypeScaleEffect(): void {
  const wide = useMediaQuery(DESKTOP_LAYOUT_MEDIA_QUERY);
  const phone = isPhoneNavigation(wide);

  useEffect(() => {
    document.documentElement.toggleAttribute('data-phone-type-scale', phone);
    return () => {
      document.documentElement.removeAttribute('data-phone-type-scale');
    };
  }, [phone]);
}

/** A render-nothing mount point for the effect above — see its own doc comment for why here. */
export function PhoneTypeScaleEffect(): null {
  usePhoneTypeScaleEffect();
  return null;
}
